import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import MembershipSection from "./MembershipSection";

const MembershipMain = () => {
  return (
    <main>
      <Breadcrumb subtitle="Membership" title="Members Registration" />
      <MembershipSection />
    </main>
  );
};
export default MembershipMain;
